import React from 'react'
import Link from 'gatsby-link'

import ImageGallery from 'react-image-gallery';
import "react-image-gallery/styles/css/image-gallery.css";

import image1 from '../../layouts/images/project1/image1.jpg'
import image2 from '../../layouts/images/project1/image2.jpg'
import image3 from '../../layouts/images/project1/image3.jpg'
import image4 from '../../layouts/images/project1/image4.jpg'
import image5 from '../../layouts/images/project1/image12.jpg'
import image6 from '../../layouts/images/project1/image10.jpg'
import image7 from '../../layouts/images/project1/image11.jpg'

const AgeFriendlyCommunitiesPage = () => (
    <div className="container">
        <div className="row">
            <div className="col-lg-5 project-info">
                <h3>Capoeira: A Thick Description</h3>
                <div className="project-content">
                    <p>The human being is intertwined in a complex and thick ‘system of meanings‘, which is called culture. Clifford Geertz (1926-present) is best known for his ethnographic studies of Javanese culture (Indonesian island) and for his writings about the interpretation of culture. The most influential aspect of Geertz's work has been his emphasis on the importance of the symbolic -- of systems of meaning -- as it relates to culture, cultural change, and the study of culture; notice this emphasis as you watch the ethnographical movie about Capoeira culture.</p>
                    <p>With Geertz' method of thick description our research aimed to extract meaning structures that make up Capoeira and visualise it in an ethnographical movie. The narration (in German) describes in a very detailed way numerous Capoeira elements (Roda, movements, music and origin) and interprets their meanings by uncovering unspoken rules that the Capoeiristas follow every day.</p>
                    <p>Origin, the last element of the Capoeira video, contextualises the phenomenon and informs the audience about Capoeira’s historical and social background. “Capoeira as a culture of resistance” is therefore not just a sport, it is history, life philosophy as well as     complex and thick ‘systems of meanings‘, called culture.</p>
                    <p>Further information about the research will be provided upon request.</p>
                </div>
            </div>

            <div className="col-lg-7">

                <iframe width="640" height="360" src="//www.youtube.com/embed/_6PoS-5tKyE" frameborder="0" allowfullscreen></iframe>

                <br />
                <br />

                <p className="project-blurb">An ethnographical movie of Capoeira with the thick description method by Clifford Geertz.</p>

                <ul className="tags">
                    <li>Participative Observation</li>
                    <li>Interviews</li>
                    <li>Thick Description</li>
                    <li>Ethnographical Movie</li>
                    <li>Capoeira</li>
                    <li>Clifford Geertz</li>
                    <li>Interpretation of Culture (1973)</li>
                    <li>Systems of meaning</li>
                </ul>

                <div className="footer-info">
                    <p><span className="highlight">Cooperation Partner:</span> Boosted Human, Cancer Council Victoria and Vic Health</p>
                    <p><span className="highlight">Source:</span> Boosted Human</p>
                    <p><span className="highlight">Date:</span> 2014 - Present</p>
                </div>

            </div>
        </div>
    </div>
)

export default AgeFriendlyCommunitiesPage



// WEBPACK FOOTER //
// ./src/pages/projects/capoeira.js